module.exports = __webpack_public_path__ + "img/m_joinBG.32044075.jpg";